import { useEffect } from "react";
import "../../assets/css/address-toggle.css";
import { Say } from "../../languages";

type AddressToggleProps = {
  toggleFlag: string;
  setToggleFlag: (toggle: string) => void;
};

export function AddressToggle(props: AddressToggleProps) {
  const { toggleFlag, setToggleFlag } = props;

  useEffect(() => {
    if (!window?.google?.maps?.places?.Autocomplete) {
      setToggleFlag("on");
    }
  }, []);

  if (toggleFlag === "on") {
    return null;
  }

  return (
    <div className="address-toggle__wrapper">
      <button className="address-toggle" onClick={() => setToggleFlag("on")}>
        <Say phrase="payment_step.address_manual_cta" />
      </button>
    </div>
  );
}

export default AddressToggle;
